import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'iho-progressbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss'],
})
export class ProgressbarComponent {

  @Input() progressValue!: string | number
  @Input() hasAnimation!: boolean
  @Input() min!: string | number
  @Input() max!: string | number
  @Input() title!: string;
  @Input() score!: string | number

}
